import { render, staticRenderFns } from "./UserRecommendations.vue?vue&type=template&id=83028430&scoped=true&"
import script from "./UserRecommendations.vue?vue&type=script&lang=js&"
export * from "./UserRecommendations.vue?vue&type=script&lang=js&"
import style0 from "./UserRecommendations.vue?vue&type=style&index=0&id=83028430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83028430",
  null
  
)

export default component.exports